import { render, staticRenderFns } from "./ChatWidgetInSidebar.vue?vue&type=template&id=4dc1d0da"
import script from "./ChatWidgetInSidebar.vue?vue&type=script&lang=js"
export * from "./ChatWidgetInSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports